import { Accordion, Col, Container, Row } from 'react-bootstrap';

const faqData = [
    {
        id: 1,
        eventKey: '0',
        question: 'How long does it take to see results from digital marketing?',
        answer: 'Results vary depending on your starting point, industry, competition, and chosen strategies. Generally, PPC campaigns can show results within days, while SEO typically takes 3-6 months to see significant improvements. Social media marketing results often become visible within 1-3 months. We provide regular reports to track progress and make adjustments as needed.',
        defaultOpen: true
    },
    {
        id: 2,
        eventKey: '1',
        question: 'What makes your digital marketing agency different?',
        answer: 'We focus on data-driven strategies tailored to your specific business goals. Our team combines technical expertise with creative thinking to deliver campaigns that drive real results. We prioritize transparency, providing detailed reporting and insights so you always know how your marketing investment is performing.',
        defaultOpen: false
    },
    {
        id: 3,
        eventKey: '2',
        question: 'Do I need all digital marketing services or can I choose specific ones?',
        answer: 'You can choose specific services based on your business needs and goals. While an integrated approach often yields the best results, we understand that each business has unique requirements and budget considerations. We\'ll work with you to develop a customized strategy that focuses on the channels most likely to drive results for your specific situation.',
        defaultOpen: false
    },
    {
        id: 4,
        eventKey: '3',
        question: 'How do you measure the success of digital marketing campaigns?',
        answer: 'We establish clear KPIs aligned with your business goals at the start of our engagement. These might include website traffic, conversion rates, lead generation, sales, ROI, or other relevant metrics. We provide regular reports that track these KPIs and offer insights into campaign performance, allowing for data-driven optimizations.',
        defaultOpen: false
    },
    {
        id: 5,
        eventKey: '4',
        question: 'What industries do you specialize in?',
        answer: 'We have experience working with clients across various industries, including e-commerce, SaaS, healthcare, finance, education, real estate, and professional services. Our team adapts our strategies to the specific needs and challenges of each industry, ensuring relevant and effective marketing campaigns.',
        defaultOpen: false
    }
]

const FAQ = () => {
    return (
        <section className="section-lg" id="faq">
            <Container>
                <Row className="text-center mb-5">
                    <Col lg={8} className="mx-auto">
                        <span className="badge bg-success-subtle text-success fw-semibold mb-3">FAQs</span>
                        <h2 className="display-6 fw-bold mb-3">Frequently Asked Questions</h2>
                        <p className="lead text-secondary">Find answers to common questions about our digital marketing services.</p>
                    </Col>
                </Row>
                <Row>
                    <Col lg={10} className="mx-auto">
                        <Accordion defaultActiveKey="0">
                            {faqData.map((faq) => (
                                <Accordion.Item eventKey={faq.eventKey} key={faq.id} className="border-0 mb-3 shadow-sm">
                                    <Accordion.Header className="fw-semibold">
                                        {faq.question}
                                    </Accordion.Header>
                                    <Accordion.Body className="text-secondary">
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default FAQ;
